"use client";
import { useEffect,useState } from "react";
import { usePathname } from "next/navigation";
import Script from "next/script";

export default function GTM() {
  const pathname=usePathname();
  const [consent,setConsent]=useState({analytics:false,ads:false});
  useEffect(()=>{
    const check=()=>{
      try {
        const saved=JSON.parse(localStorage.getItem("hill_medical_consent_v2") ?? "{}");
        setConsent({analytics:saved.analytics_storage==="granted",ads:saved.ad_storage==="granted"});
      }catch {setConsent({analytics:false,ads:false});}
    };
    check();window.addEventListener("analytics-consent-updated",check);window.addEventListener("storage",check);
    return()=>{window.removeEventListener("analytics-consent-updated",check);window.removeEventListener("storage",check);};
  },[]);
  if(pathname.startsWith("/admin")||(!consent.analytics&&!consent.ads))return null;
  return <Script id="gtm-script" strategy="afterInteractive">{`
    window.dataLayer=window.dataLayer||[];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent','default',{analytics_storage:'${consent.analytics?"granted":"denied"}',ad_storage:'${consent.ads?"granted":"denied"}',ad_user_data:'${consent.ads?"granted":"denied"}',ad_personalization:'${consent.ads?"granted":"denied"}'});
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-P4XL6WCH');
  `}</Script>;
}
